import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-223">
      <button className="flex justify-between items-center w-full text-left font-medium text-gray-800" onClick={() => setIsOpen(!isOpen)} data-id="element-224">
        <span data-id="element-225">{question}</span>
        {isOpen ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-226" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-227" />}
      </button>
      {isOpen && <div className="mt-2 text-gray-600 pl-0" data-id="element-228">
          <p data-id="element-229">{answer}</p>
        </div>}
    </div>;
};
interface FAQAccordionProps {
  faqs: FAQItemProps[];
}
const FAQAccordion = ({
  faqs
}: FAQAccordionProps) => {
  return <div className="space-y-1" data-id="element-230">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-231" />)}
    </div>;
};
export default FAQAccordion;